<template>
    <div style="width: 100%;">
        <el-card style="width: 100%;margin-bottom: 20px;" class="box-card">
            <div style="margin-left: 200px;">
                <div style="font-size: 16px;margin-bottom: 15px;">{{orderStatusText}}</div>
                <div style="margin: 50px 0;">
                    <el-steps :active="0" finish-status="success">
                        <el-step title="集采合同"></el-step>
                        <el-step title="农场发货"></el-step>
                        <el-step title="集采商收货"></el-step>
                        <el-step title="平台对账"></el-step>
                    </el-steps>
                </div>
            </div>
        </el-card>
        <el-card style="width: 100%;margin-bottom: 20px;" class="box-card">
            <div style="margin-left: 200px;">
                <div style="font-size: 16px;margin-bottom: 15px;">基础资料</div>
                <div style="display: flex;justify-content: space-between;" v-if="orderDate.collector">
                    <div style="display: flex;width: 50%;">
                        <div style="display: grid" >
                            <div style="font-size: 14px;height: 20px;font-weight: 300;">
                                集采商名称：{{orderDate.collector.name}}
                            </div>
                            <div v-if="orderDate.collector.organizationType == '1'" style="font-size: 14px;height: 20px;font-weight: 300;">
                                机构类型：国有企业
                            </div>
                            <div v-if="orderDate.collector.organizationType == '2'" style="font-size: 14px;height: 20px;font-weight: 300;">
                                机构类型：集体所有制企业
                            </div>
                            <div v-if="orderDate.collector.organizationType == '3'" style="font-size: 14px;height: 20px;font-weight: 300;">
                                机构类型：股份制企业
                            </div>
                            <div v-if="orderDate.collector.organizationType == '4'" style="font-size: 14px;height: 20px;font-weight: 300;">
                                机构类型：联营企业
                            </div>
                            <div v-if="orderDate.collector.organizationType == '5'" style="font-size: 14px;height: 20px;font-weight: 300;">
                                机构类型：个人独资企业
                            </div>
                            <div style="font-size: 14px;height: 20px;font-weight: 300;">
                                联系地址：{{orderDate.collector.address}}
                            </div>
                        </div>
                    </div>

                    <div style="margin-right: 280px;display: flex;">
                        <div>营业执照：</div>
                        <div class="demo-image__preview">
                            <el-image
                                    style="width: 160px;height:100px;"
                                    :src="orderDate.collector.businessLicenseFile.url"
                                    :preview-src-list="[orderDate.collector.businessLicenseFile.url]">
                            </el-image>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card style="width: 100%;margin-bottom: 20px;" class="box-card">
            <div style="margin-left: 200px;">
                <div style="display: flex;align-content: center">
                    <div style="font-size: 16px;margin-bottom: 15px;margin-right: 20px;">收货人信息</div>

                    <div style="font-size: 12px;color: #2894FF;line-height: 20px;" >
                        <el-button type="primary" size="mini" @click="edit()" icon="el-icon-edit">编辑</el-button>
                    </div>
                </div>
                <div style="display: flex;justify-content: space-between;">
                    <div style="display: flex;width: 50%;">
                        <div style="display: grid;">
                            <div style="font-size: 14px;height: 20px;font-weight: 300;">收货人：{{orderDate.receiptName}}</div>
                            <div style="font-size: 14px;height: 20px;font-weight: 300;">联系手机号码：{{orderDate.receiptPhone}}</div>
                            <div style="font-size: 14px;height: 20px;font-weight: 300;">收货地址：{{orderDate.receiptAddress}}</div>
                            <div style="font-size: 14px;height: 20px;display: flex;font-weight: 300;">
                                <div>唯一辨识码:</div>
                                <div style="color:red;font-weight: 500;margin: 0 20px;">{{orderDate.verifyCode}}</div>
                                <div>
                                    <el-button :disabled="orderDate.associationOrderId==null?false:true" size="mini" @click="sendSmsMsg()">再次发送</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid;">
                        <div style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">
                            订单编号：{{orderDate.id}}
                        </div>
                        <div style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">
                            创建订单时间：{{orderDate.createTime}}
                        </div>
                        <div style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">
                            预付款支付时间：2022-06-24 10:00
                        </div>
                        <div v-if="orderDate.payType=='WeiXin'" style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">支付方式：微信小程序支付</div>
                        <div v-if="orderDate.payType=='WeiXinPublicAccount'" style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">支付方式：小程序+公账</div>
                        <div v-if="orderDate.payType=='PublicAccount'" style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">支付方式：公账</div>
                        <div style="font-size: 14px;height: 20px;font-weight: 300;margin-bottom: 10px;">订单类型：集采订单</div>
                        <div style="font-size: 14px;height: 20px;font-weight: 300;">订单来源：集采商合同</div>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card style="width: 100%;margin-bottom: 20px;" class="box-card">
            <div style="margin-left: 200px;margin-bottom: 30px;">
                <div style="font-size: 16px;margin-bottom: 15px;">款项支付</div>
                <div style="display: flex;justify-content: space-between;width: 80%;">
                    <div v-if="orderDate.payType=='WeiXin' || orderDate.payType=='WeiXinPublicAccount'">
                        <div style="display: flex;align-content: center;align-items: center;margin-bottom: 20px;">
                            <div style="font-size: 14px;">微信小程序预付款：</div>
                            <div v-if="orderDate.payStauts=='0'" style="color: red;margin-right: 20px;font-size: 12px;margin-right: 30px;">未支付</div>
                            <div v-if="orderDate.payStauts=='1'" style="color: red;margin-right: 20px;font-size: 12px;margin-right: 30px;">已支付</div>
                            <div>
                                <el-button v-if="orderDate.associationOrderId!=null" size="mini" @click="checkAssociationOrder">查看关联订单</el-button>
                            </div>
                        </div>
                        <el-upload
                                :headers="headers"
                                :on-preview="handPreview"
                                :on-progress="progress"
                                :on-change="upLoadWeiXinPay"
                                :on-success="upLoadSeccessWeiXinPay"
                                :on-remove="removeUploadWeiXinPay"
                                class="upload-demo"
                                name="multipartFile"
                                :data="uploadParam.WeiXinPrepaid"
                                :file-list="orderDate.weiXinPrepaIds"
                                :action="baseURL+'/collection/upload'"
                                :multiple="true"
                                :auto-upload="true">
                            <el-button size="small" type="primary">导入订单文件</el-button>
                        </el-upload>
                    </div>
                    <div v-if="orderDate.payType!='WeiXin'">
                        <div style="display: flex;align-content: center;margin-bottom: 20px;">
                            <div style="font-size: 14px;">公帐转款分帐款：</div>
                            <div v-if="orderDate.payType=='PublicAccount'" style="font-size: 14px;">（备注：个体户集采商使用电子支付方式微信、支付宝或网银向农户支付货款，或向心乡农公账转款）</div>
                        </div>
                        <el-upload
                                :headers="headers"
                                :on-preview="handPreview"
                                :on-progress="progress"
                                :on-change="upLoadPublicAccount"
                                :on-success="upLoadSeccessPublicAccount"
                                :on-remove="removeUploadPublicAccount"
                                accept=".pdf,.jpg,.png,.jpeg"
                                class="upload-demo"
                                name="multipartFile"
                                :data="uploadParam.PublicAccount"
                                :file-list="orderDate.publicAccounts"
                                :action="baseURL+'/collection/upload'"
                                :auto-upload="true">
                            <el-button size="small" type="primary">上传转款凭证</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div v-if="orderDate.payType!='WeiXin'" style="margin-left: 200px;">
                <div style="display: flex;align-content: center;align-items: center">
                    <div style="font-size: 14px;margin-right: 150px;">款项帐单</div>
                    <div>
                        <el-button @click="dialogBill = true" size="mini">查看账单</el-button>
                        <el-dialog title="款项账单" :visible.sync="dialogBill">
                            <div style="display: flex;justify-content: space-around;width: 100%;margin-bottom: 20px;">
                                <div style="display: flex;font-size: 16px;">
                                    <span>集采金额（¥）</span>
                                    <span style="color: red;font-weight: 600;">{{orderDate.amount}}</span>
                                </div>
                                <div style="display: flex;font-size: 16px;" v-if="orderDate.payType!='PublicAccount'">
                                    <span>微信小程序预付款（¥）</span>
                                    <span style="color: red;font-weight: 600;">{{orderDate.omsOrderInfo?orderDate.omsOrderInfo.skuSumPrice:''}}</span>
                                </div>
                            </div>
                            <el-form :model="billData">
                                <el-form-item label="公帐转款分帐款（¥）">
                                    <el-input v-model="billData.amount" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="公帐转款账户">
                                    <el-input v-model="billData.publicAccountNo" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="开户名称">
                                    <el-input v-model="billData.accountName" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="开户行">
                                    <el-input v-model="billData.bank" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="转账说明">
                                    <el-select v-model="billData.transferType" placeholder="请选择">
                                        <el-option
                                                v-for="item in transferTypeOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="转账时间">
                                    <el-date-picker
                                            v-model="billData.transferTime"
                                            type="date"
                                            placeholder="转账时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="收款时间">
                                    <el-date-picker
                                            v-model="billData.collectionTime"
                                            type="date"
                                            placeholder="转账时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="转账单号">
                                    <el-input v-model="billData.transferNo" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogBill = false">取 消</el-button>
                                <el-button type="primary" @click="dialogBill = false">确 定</el-button>
                            </div>
                        </el-dialog>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card style="width: 100%;margin-bottom: 20px;" class="box-card">
            <div style="margin-left: 200px;margin-bottom: 30px;">
                <div style="font-size: 16px;margin-bottom: 15px;">商品信息</div>
            </div>
            <div style="margin-left: 200px;" v-if="orderDate.commodity">
                <el-table
                        :data="[orderDate.commodity]"
                        border
                        stripe
                        style="width: 100%">
                    <el-table-column
                            fixed
                            prop="name"
                            label="商品信息"
                            width="350">
                        <template slot-scope="prop">
                            <div style="display: flex;align-content: center;align-items: center;">
                                <img style="width: 50px;height: 50px"
                                     :src="prop.row.skuDefaultImgUrl">
                                <div style="display: grid;margin-left: 10px;">
                                    <div style="font-size: 12px;color: #2894FF;">{{prop.row.skuName}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="skuPrice"
                            label="单价(¥/kg)"
                            width="200">
                    </el-table-column>

                    <el-table-column
                            label="总重量（斤）"
                            width="200">
                        <template slot-scope="prop">
                            <div style="font-size: 12px;">{{orderDate.totalWeight}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="物流货运单号"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            label="发货状态"
                            width="200">
                        <template slot-scope="prop">
                            <span v-if="orderDate.status == '0'">待绑定</span>
                            <span v-if="orderDate.status == '1'">已绑定</span>
                            <span v-if="orderDate.status == '2'">待发货</span>
                            <span v-if="orderDate.status == '3'">已发货</span>
                            <span v-if="orderDate.status == '4'">已完成</span>
                            <span v-if="orderDate.status == '5'">已关闭</span>
                            <span v-if="orderDate.status == '6'">售后处理</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="amount"
                            label="采集金额"
                            width="300">
                        <template slot-scope="prop">
                            <div style="font-size: 12px;">{{orderDate.amount}}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display: grid;justify-content: end;margin-top: 20px;">
                    <div style="font-size: 14px;font-weight: 300;margin-bottom: 20px;">单价：¥{{orderDate.commodity.skuPrice}}/{{orderDate.commodity.skuWeight}}</div>
                    <div style="display: flex;margin-bottom: 20px;align-items: center;">
                        <div style="font-size: 14px;font-weight: 300;margin-right: 10px;">运费：¥{{orderDate.freight}}</div>
                        <div>
                            <el-button size="mini" @click="checkPayCertificate">查看支付凭证</el-button>
                            <el-dialog title="配送运费账单" :visible.sync="dialogPayCertificate">
                                <div style="margin-bottom: 80px;">
                                    <el-upload
                                            :headers="headers"
                                            :on-preview="handPreview"
                                            :on-progress="progress"
                                            :on-change="upLoadPayCertificate"
                                            :on-success="upLoadSeccessPayCertificate"
                                            :on-remove="removeUploadPayCertificate"
                                            accept=".pdf,.jpg,.png,.jpeg"
                                            class="upload-demo"
                                            name="multipartFile"
                                            :data="uploadParam.DeliveryFreight"
                                            :file-list="orderDate.deliveryFreights"
                                            :action="baseURL+'/collection/upload'"
                                            :auto-upload="true">
                                        <el-button size="small"  type="primary">上传转款凭证</el-button>
                                    </el-upload>
                                </div>
                                <div>备注：公帐转款分帐款可能包含配送运费转款</div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dialogPayCertificate = false">取 消</el-button>
                                    <el-button type="primary" @click="dialogPayCertificate = false">确 定</el-button>
                                </div>
                            </el-dialog>
                        </div>
                    </div>
                    <div style="font-size: 14px;font-weight: 300;margin-bottom: 20px;">打包费：¥0.00</div>
                    <div style="font-weight: 500;font-size: 16px;">本单实收：¥{{orderDate.amount + orderDate.freight}}</div>
                </div>
                <div style="display: flex;justify-content: center;">
                    <div style="margin-right: 10px;">审核状态：</div>
                    <el-button v-if="orderDate.status!='5'" :type="orderDate.status=='2'?'primary':''" @click="updateStatus('3')" style="margin-right: 20px;" size="small">已发货</el-button>
                    <el-button v-if="orderDate.status!='5'" :type="orderDate.status=='3'?'primary':''" @click="updateStatus('4')" style="margin-right: 20px;" size="small">已结算完成</el-button>
                    <el-dialog title="结算账单" :visible.sync="dialogSettlementFinish">
                        <div style="margin-bottom: 80px;">
                            <el-upload
                                    :headers="headers"
                                    :on-preview="handPreview"
                                    :on-progress="progress"
                                    :on-change="upLoadSettlementBill"
                                    :on-success="upLoadSeccessSettlementBill"
                                    :on-remove="removeUploadSettlementBill"
                                    accept=".pdf,.jpg,.png,.jpeg"
                                    class="upload-demo"
                                    name="multipartFile"
                                    :data="uploadParam.SettlementBill"
                                    :file-list="orderDate.settlementBills"
                                    :action="baseURL+'/collection/upload'"
                                    :auto-upload="true">
                                <el-button size="small" type="primary">上传转款凭证</el-button>
                            </el-upload>
                        </div>
                        <div>备注：心乡农公帐向农户转款结算的打印票据或电子转款记录，包括截图记录</div>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogSettlementFinish = false">取 消</el-button>
                            <el-button type="primary" @click="SettlementFinish()">确 定</el-button>
                        </div>
                    </el-dialog>
                    <el-button v-if="orderDate.status!='5'" @click="updateStatus('5')" style="margin-right: 20px;" size="small">关闭订单</el-button>
                    <el-button v-if="orderDate.status!='5'" @click="updateStatus('6')" style="margin-right: 20px;" size="small">售后处理</el-button>
<!--                    <el-button @click="updateStatus('7')" size="small">取 消</el-button>-->
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    import MyTable from "../../components/content/myTable/MyTable";
    import {
        queryCentralizedPurchaseOrderDetailById,
        updateCentralizedPurchaseOrderStatus,
        newVue,
        sendSmsMsg,
    } from "../../network/collector";

    export default {
        name: "CollectorOrderDetail",
        components: {MyTable},
        data() {
            return {
                orderId: null,
                orderStatusText:"待发货",
                orderDate:{
                },
                baseURL:newVue.baseURL,//請求地址
                tableData: [
                    {
                        commodityName: "贝贝瓜",
                        commodityPrice: 5.0,
                        totalWeight: 8000,
                        status: "2",
                        amount: 40000.0,
                    }
                ],//商品信息
                headers: {},
                dialogPayCertificate: false,//是否展示 支付凭证对话框
                dialogSettlementFinish: false,//是否展示 结算账单
                dialogBill:false,//是否展示账单
                billData:{},//账单信息
                transferTypeOptions:[
                    {
                        value:"0",
                        label:"柜机转款"
                    },
                    {
                        value:"1",
                        label:"网络转款"
                    },
                ],//账单说明
                uploadParam:{
                    WeiXinPrepaid:{type:"WeiXinPrepaid"},
                    DeliveryFreight:{type:"DeliveryFreight"},
                    SettlementBill:{type:"SettlementBill"},
                    PublicAccount:{type:"PublicAccount"},
                },
                loadingMsg:null,
            }
        },
        created() {
            newVue.obj = this;
            this.authorization=newVue.obj.common.loginInfo.jwtToken;
            this.headers.Authorization = this.authorization;
            this.common.HeaderLocationTwo.href = "/collector/orderDetail";
            this.common.HeaderLocationTwo.name = "采集单管理";
            this.common.HeaderLocationThree.name = "采集单详情";
            if (this.$route.params.id != null) {
                this.orderId = this.$route.params.id;
                queryCentralizedPurchaseOrderDetailById(this.orderId).then(res => {
                    if (res.code == "200"){
                        console.log(res.data);
                        this.orderDate = res.data;
                        if (res.data.collectBill){
                            this.billData = res.data.collectBill;
                        }
                        switch (res.data.status) {
                            case "2":
                                this.orderStatusText = "待发货";
                                break;
                            case "3":
                                this.orderStatusText = "已发货";
                                break;
                            case "4":
                                this.orderStatusText = "已完成";
                                break;
                            case "5":
                                this.orderStatusText = "已关闭";
                                break;
                            case "6":
                                this.orderStatusText = "售后处理";
                                break;
                        }
                    }
                })
            }
        },
        methods: {
            ///配送运费账单///
            checkPayCertificate() {//查看支付凭证
                this.dialogPayCertificate = true;
            },
            upLoadSeccessPayCertificate(response, file, fileList){
                this.loadingMsg.close();
                this.orderDate.deliveryFreights = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = fileList[i].name;
                        item["id"] = fileList[i].uid;
                        item["fileSize"] = fileList[i].raw?fileList[i].raw.size:fileList[i].fileSize;
                        item["fileType"] = fileList[i].raw?fileList[i].raw.type:fileList[i].fileType;
                        item["associationType"] = "DeliveryFreight";
                        item["url"] = fileList[i].response?fileList[i].response.data[0]:fileList[i].url;
                        this.orderDate.deliveryFreights.push(item);
                    }
                }else {
                    this.orderDate.deliveryFreights = [];
                }
            },
            upLoadPayCertificate (file, fileList) {
                //this.$refs.upLoad.submit();
            },
            removeUploadPayCertificate(file, fileList){//删除合同文件
                this.orderDate.deliveryFreights = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = file.name;
                        item["id"] = file.uid;
                        item["fileSize"] = file.raw.size;
                        item["fileType"] = file.raw.type;
                        item["associationType"] = "DeliveryFreight";
                        this.orderDate.deliveryFreights.push(item);
                    }
                }else {
                    this.orderDate.deliveryFreights = [];
                }
            },
            ///配送运费账单///

            ///微信预支付文件///
            upLoadSeccessWeiXinPay(response, file, fileList){
                this.loadingMsg.close();
                debugger
                this.orderDate.weiXinPrepaIds = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = fileList[i].name;
                        item["id"] = fileList[i].uid;
                        item["fileSize"] = fileList[i].raw?fileList[i].raw.size:fileList[i].fileSize;
                        item["fileType"] = fileList[i].raw?fileList[i].raw.type:fileList[i].fileType;
                        item["associationType"] = "WeiXinPrepaId";
                        item["url"] = fileList[i].response?fileList[i].response.data[0]:fileList[i].url;
                        this.orderDate.weiXinPrepaIds.push(item);
                    }
                }else {
                    this.orderDate.weiXinPrepaIds = [];
                }
            },
            upLoadWeiXinPay (file, fileList) {
                //this.$refs.upLoad.submit();
                },
            removeUploadWeiXinPay(file, fileList){//删除合同文件
                this.orderDate.weiXinPrepaIds = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = file.name;
                        item["id"] = file.uid;
                        item["fileSize"] = file.raw.size;
                        item["fileType"] = file.raw.type;
                        item["associationType"] = "WeiXinPrepaId";
                        this.orderDate.weiXinPrepaIds.push(item);
                    }
                }else {
                    this.orderDate.weiXinPrepaIds = [];
                }
            },
            ///微信预支付文件///

            ///公帐转款分帐款///
            upLoadSeccessPublicAccount(response, file, fileList){
                this.loadingMsg.close();
                this.orderDate.publicAccounts = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = fileList[i].name;
                        item["id"] = fileList[i].uid;
                        item["fileSize"] = fileList[i].raw?fileList[i].raw.size:fileList[i].fileSize;
                        item["fileType"] = fileList[i].raw?fileList[i].raw.type:fileList[i].fileType;
                        item["associationType"] = "PublicAccount";
                        item["url"] = fileList[i].response?fileList[i].response.data[0]:fileList[i].url;
                        this.orderDate.publicAccounts.push(item);
                    }
                }else {
                    this.orderDate.publicAccounts = [];
                }
            },
            upLoadPublicAccount (file, fileList) {
                //this.$refs.upLoad.submit();
                },
            removeUploadPublicAccount(file, fileList){//删除合同文件
                this.orderDate.publicAccounts = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = file.name;
                        item["id"] = file.uid;
                        item["fileSize"] = file.raw.size;
                        item["fileType"] = file.raw.type;
                        item["associationType"] = "PublicAccount";
                        this.orderDate.publicAccounts.push(item);
                    }
                }else {
                    this.orderDate.publicAccounts = [];
                }
            },
            ///公帐转款分帐款///

            ///结算账单///
            upLoadSeccessSettlementBill(response, file, fileList){
                this.loadingMsg.close();
                this.orderDate.settlementBills = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = fileList[i].name;
                        item["id"] = fileList[i].uid;
                        item["fileSize"] = fileList[i].raw?fileList[i].raw.size:fileList[i].fileSize;
                        item["fileType"] = fileList[i].raw?fileList[i].raw.type:fileList[i].fileType;
                        item["associationType"] = "SettlementBill";
                        item["url"] = fileList[i].response?fileList[i].response.data[0]:fileList[i].url;
                        this.orderDate.settlementBills.push(item);
                    }
                }else {
                    this.orderDate.settlementBills = [];
                }
            },
            upLoadSettlementBill (file, fileList) {
                //this.$refs.upLoad.submit();
            },
            removeUploadSettlementBill(file, fileList){//删除合同文件
                this.orderDate.settlementBills = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = file.name;
                        item["id"] = file.uid;
                        item["fileSize"] = file.raw.size;
                        item["fileType"] = file.raw.type;
                        item["associationType"] = "SettlementBill";
                        this.orderDate.settlementBills.push(item);
                    }
                }else {
                    this.orderDate.settlementBills = [];
                }
            },
            ///结算账单///
            updateStatus(status) {//审核状态

                switch (status) {
                    case "3":
                        if (this.orderDate.status!='2'){
                            this.confirm("warning","当前状态不是待发货不能审核发货");
                            return;
                        }
                        if (this.formValidation(status)){
                            this.updateOrder(status);
                        }
                        break;
                    case "4":
                        debugger
                        if (this.orderDate.status!='3' && this.orderDate.status!='6'){
                            this.confirm("warning","当前状态不是已发货或者售后处理不能进行审核完成");
                            return;
                        }
                        this.dialogSettlementFinish = true;
                        break;
                    case "5":
                        if (this.orderDate.payType == 'PublicAccount'){
                            if (this.orderDate.status!='2'){
                                this.confirm("warning","当前状态不能进行审核关闭");
                                return;
                            }
                        }else {
                            if (this.orderDate.status!='1'){
                                this.confirm("warning","当前状态不能进行审核关闭");
                                return;
                            }
                        }

                        this.updateOrder(status);
                        break;
                    case "6":
                        if (this.orderDate.status!='3'){
                            this.confirm("warning","当前状态不是已发货不能进行售后");
                            return;
                        }
                        this.updateOrder(status);
                        break;
                }
            },
            checkAssociationOrder(){//查看关联订单
                this.$router.push("/order/data/"+ this.orderDate.associationOrderId);
            },
            sendSmsMsg() {//发送采集单的验证码给采集员
                let map = {
                    orderid: this.orderId.substring(this.orderId.length -4,this.orderId.length),
                    code: this.orderDate.verifyCode
                };
                sendSmsMsg(this.orderDate.collector.phone, "SMS_243955764", JSON.stringify(map)).then(res => {
                    debugger
                    if (res.code == "200") {
                        this.$message({
                            message: '短信发送成功',
                            type: 'success'
                        });
                    }
                })
            },
            updateOrder(status){
                this.orderDate.status = status;
                if (this.billData!=null){
                    this.orderDate["collectBill"] = this.billData;
                }
                updateCentralizedPurchaseOrderStatus(this.orderDate).then(res => {
                    if (res.code == "200"){
                        this.confirm('success',"审核成功");
                        if (status == '4'){
                            this.dialogSettlementFinish = false;
                        }
                    }
                })
            },
            edit(){//编辑
                this.$router.push("/collector/orderInsert/"+ this.orderId);
            },
            formValidation(status){//表单审核校验  根据审核状态
                if (status == "3"){
                    if (this.orderDate.payType == "WeiXin"){
                        if (!this.orderDate.weiXinPrepaIds || this.orderDate.weiXinPrepaIds.length == 0){
                            this.confirm("warning","请上传微信小程序预付款文件");
                            return false;
                        }

                    }else if (this.orderDate.payType == "WeiXinPublicAccount"){
                        if (!this.orderDate.weiXinPrepaIds || this.orderDate.weiXinPrepaIds.length == 0){
                            this.confirm("warning","请上传微信小程序预付款文件");
                            return false;
                        }
                        if (!this.orderDate.publicAccounts || this.orderDate.publicAccounts.length == 0){
                            this.confirm("warning","请上传公帐转款分帐款凭证");
                            return false;
                        }
                    }else if (this.orderDate.payType == "PublicAccount"){
                        if (!this.orderDate.publicAccounts || this.orderDate.publicAccounts.length == 0){
                            this.confirm("warning","请上传公帐转款分帐款凭证");
                            return false;
                        }
                    }
                    debugger
                    if (this.orderDate.payType == "WeiXinPublicAccount" || this.orderDate.payType == "PublicAccount"){
                        if ( this.billData.publicAccountNo == null || this.billData.accountName == null
                            || this.billData.bank == null || this.billData.transferType == null || this.billData.transferTime == null
                            || this.billData.collectionTime == null || this.billData.transferNo == null
                        ){
                            this.confirm("warning","账单信息填写是否确认完成？");
                            return false;}
                    }

                    if (!this.orderDate.deliveryFreights || this.orderDate.deliveryFreights.length == 0){
                        this.confirm("warning","请上传配送运费账单");
                        return false;
                    }
                }else if (status == "4"){
                    if (!this.orderDate.settlementBills || this.orderDate.settlementBills.length == 0){
                        this.confirm("warning","请上传结算账单凭证");
                        return false;
                    }
                }
                return true;
            },
            SettlementFinish(){
                if (this.formValidation('4')){
                    this.updateOrder('4');
                }
            },
            confirm(type,msg){//提示
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: type
                })
            },
            progress(){
                this.loadingMsg = this.$loading({
                    lock: true,
                    text: '正在上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            handPreview(file){
                window.open(file.url,"_blank");
            }

        }
    }
</script>

<style scoped>

</style>
